import { useQuery } from '@apollo/react-hooks'
import { LIST_BANNERS, BannerConnection, QueryListBannersArgs, Maybe } from 'vo-components'

export function useBannersQuery() {
    return useQuery<{ listBanners: Maybe<BannerConnection> }, QueryListBannersArgs>(LIST_BANNERS, {
        variables: { listing_status: 'HOME' },
    })
}
